import { Patient } from "../types/patient";
import { BORN, URN } from "../util/const";
import { FormatDateForDisplay } from "../util/data-utils";

export type SinglePatientProps = {
  patient: Patient;
};

const PatientDisplay = (props: SinglePatientProps) => {

  const CalculateAge = (dateStr: string | undefined) => {
  
    if(dateStr === undefined || dateStr === null || dateStr.length === 0)
    {
      return;
    }
  
    var today = new Date();
    var dob = new Date(dateStr);
    var age = today.getFullYear() - dob.getFullYear();
    var m = today.getMonth() - dob.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
        age--;
    }
    return `(${age}yrs)`;
  }

  const getSalutation = (title: string) => {
    if (title === undefined || title == null || title.length === 0) {
      return "";
    }
    return `(${title})`;
  };

  return (
    <>
    <h4>
      {props.patient.familyName}, {props.patient.givenNames}{" "}
      {getSalutation(props.patient.salutation!)}
    </h4>
    <i className="me-2">{BORN}:</i>
      {FormatDateForDisplay(props.patient.birthDate)}{" "}
      {CalculateAge(props.patient.birthDate!)}
    <br />
    <i className="me-2">{URN}:</i>
      {props.patient.urn}
    </>
  );
}

export default PatientDisplay;